export default __webpack_public_path__ + "static/media/avatar01.5b29a764.jpg";